<div class="header-container">
  <div class="profile-details">
    <div class="main-profile">
      <button mat-button [matMenuTriggerFor]="menu" class="profile-name">
        {{ userName }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="logoutClass">
        <button mat-menu-item routerLink="profile">Profile</button>
        <button mat-menu-item (click)="signOut()">Log Out</button>
      </mat-menu>
    </div>
    <div class="profile-image">
      <img class="" [src]="imageSrc" alt="profile-image" *ngIf="imageSrc != '' " />
      <img class="" src="./assets/images/teksun-logo-updated.png" alt="profile photo" *ngIf="imageSrc == '' || !imageSrc" />
    </div>
  </div>
</div>